const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const;

// A formatter costs far more than a format() call, and a table asks for the same few zones on every row.
const DAY_FORMATS = new Map<string | undefined, Intl.DateTimeFormat>();
const TIME_FORMATS = new Map<string | undefined, Intl.DateTimeFormat>();

function formatterFor(cache: Map<string | undefined, Intl.DateTimeFormat>, zone: string | undefined, make: () => Intl.DateTimeFormat): Intl.DateTimeFormat {
  let format = cache.get(zone);
  if (!format) {
    format = make();
    cache.set(zone, format);
  }
  return format;
}

/** YYYY-MM-DD of `d` in `zone` (the browser zone when omitted). */
export function zoneDayKey(d: Date, zone?: string): string {
  return formatterFor(DAY_FORMATS, zone, () => new Intl.DateTimeFormat('en-CA', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit' })).format(d);
}

/** "30 Sep" — a fixed month table: ICU ≥ 72 prints en-GB September as "Sept". */
export function shortDate(d: Date, zone?: string): string {
  const [, month, day] = zoneDayKey(d, zone).split('-');
  return `${Number(day)} ${MONTHS[Number(month) - 1]}`;
}

/** "00:05" — 24-hour clock in `zone`. */
export function shortTime(d: Date, zone?: string): string {
  return formatterFor(TIME_FORMATS, zone, () => new Intl.DateTimeFormat('en-GB', { timeZone: zone, hour: '2-digit', minute: '2-digit', hour12: false })).format(d);
}
